<ng-template #checkBox>
  <app-usf-checkbox
    data-cy="recipe-card-checkbox"
    [isSelected]="cardData.isSelected"
  ></app-usf-checkbox>
  <div class="cut-off"></div>
</ng-template>

<ng-template #image>
  <img
    *ngIf="!!cardData.imageSrc"
    class="recipe-image"
    [attr.data-cy]="'recipe-card-image-' + cardData.index"
    [src]="cardData.imageSrc"
  />
  <div
    *ngIf="!cardData.imageSrc"
    data-cy="product-card-no-image-icon"
    class="recipe-image"
  >
    <ion-icon name="restaurant"></ion-icon>
  </div>
</ng-template>

<ng-template #recipeName>
  <p
    class="text-body bold"
    [attr.data-cy]="'recipe-card-recipe-name-' + cardData.index"
    [class.mobile-recipe]="platform === platformRef.mobile"
  >
    {{ cardData.recipeName | truncateWithEllipsis: 60 }}
  </p>
</ng-template>
<ng-template #group>
  <p
    class="text-body text-green"
    [attr.data-cy]="'recipe-card-group-' + cardData.index"
    [class.mobile-group]="platform === platformRef.mobile"
  >
    {{ cardData.groupName | truncateWithEllipsis: 30 }}
  </p>
</ng-template>
<ng-template #yield>
  <p class="text-body" [attr.data-cy]="'recipe-card-yield-' + cardData.index">
    {{ cardData.yield }}
  </p>
</ng-template>
<ng-template #serving>
  <p class="text-body" [attr.data-cy]="'recipe-card-serving-' + cardData.index">
    {{ cardData.servingPerBatch }}
  </p>
</ng-template>
<ng-template #ServingSize>
  <p
    class="text-body"
    [attr.data-cy]="'recipe-card-seving-size-' + cardData.index"
  >
    {{ cardData.serving | translate }}
  </p>
</ng-template>
<ng-template #costRecipe>
  <p
    class="text-body"
    [attr.data-cy]="'recipe-card-cost-yom-' + cardData.index"
  >
    {{ cardData.cost | currency }}
  </p>
</ng-template>
<ng-template #costServing>
  <p
    class="text-body"
    [attr.data-cy]="'recipe-card-cost-serving-' + cardData.index"
  >
    {{ cardData.costPerServing | currency }}
  </p>
</ng-template>

<ng-template #mobileUOMCost>
  <div class="mobile-uom-cost flex-row-center">
    <p
      class="text-body"
      [attr.data-cy]="'recipe-card-cost-uom-' + cardData.index"
      *ngIf="!!cardData.serving"
    >
      {{ cardData.serving }}
    </p>
    <img
      src="assets/images/separator.png"
      class="small"
      *ngIf="!!cardData.serving"
    />
    <p
      class="text-body"
      [attr.data-cy]="'recipe-card-cost-serving-' + cardData.index"
    >
      {{ cardData.costPerServing | currency }}
    </p>
  </div>
</ng-template>
<ng-template #ellipsis>
  <div
    [attr.data-cy]="'recipe-card-ellipsis-section' + cardData.index"
    class="ellipsis"
    id="{{ cardData.recipeId }}"
    (click)="onEllipsisClick($event)"
  >
    <ion-icon
      class="ellipsis-icon text-green"
      data-cy="recipe-card-ellipsis-icon"
      name="ellipsis-vertical"
    ></ion-icon>
  </div>
</ng-template>

<ng-template #desktopTabletMain>
  <ion-col
    data-cy="recipe-card-checkbox-column"
    class="recipe-selector"
    [size]="platform === platformRef.desktop ? 0.6 : 0.8"
    [class.selected]="cardData.isSelected"
    (click)="onClick($event)"
  >
    <ng-container [ngTemplateOutlet]="checkBox"></ng-container>
  </ion-col>
  <ion-col
    class="image"
    [size]="platform === platformRef.desktop ? 1 : 1.15"
    [offset]="platform === platformRef.desktop ? 0.05 : 0.06"
  >
    <ng-container [ngTemplateOutlet]="image"></ng-container
  ></ion-col>
  <ion-col
    class="recipe"
    [size]="platform === platformRef.desktop ? 2 : 2.25"
    offset="0.2"
  >
    <ng-container [ngTemplateOutlet]="recipeName"></ng-container>
  </ion-col>
  <ion-col
    class="group"
    [size]="platform === platformRef.desktop ? 1 : 1.25"
    offset="0.2"
  >
    <ng-container [ngTemplateOutlet]="group"></ng-container>
  </ion-col>
  <ion-col
    *ngIf="platform !== platformRef.tablet"
    class="yield"
    [size]="1"
    offset="0.2"
  >
    <ng-container [ngTemplateOutlet]="yield"></ng-container
  ></ion-col>
  <ion-col
    class="serving"
    [size]="platform === platformRef.desktop ? 1 : 1.15"
    offset="0.2"
  >
    <ng-container [ngTemplateOutlet]="serving"></ng-container>
  </ion-col>
  <ion-col
    class="serving-size"
    [size]="platform === platformRef.desktop ? 1 : 1.25"
    offset="0.2"
  >
    <ng-container [ngTemplateOutlet]="ServingSize"></ng-container>
  </ion-col>
  <ion-col class="cost-per-recipe" [size]="1" offset="0.2">
    <ng-container [ngTemplateOutlet]="costRecipe"></ng-container
  ></ion-col>
  <ion-col class="cost-per-serving" [size]="1" offset="0.2">
    <ng-container [ngTemplateOutlet]="costServing"></ng-container
  ></ion-col>
  <ion-col class="ellipsis" [size]="0.5" offset="0.3">
    <ng-container [ngTemplateOutlet]="ellipsis"></ng-container
  ></ion-col>
</ng-template>

<ng-template #mobileMain>
  <ion-col class="mobile-image" size="2">
    <ng-container [ngTemplateOutlet]="image"></ng-container>
  </ion-col>
  <ion-col class="recipe-info" size="8.5" offset="0.5">
    <ion-row>
      <ion-col>
        <ng-container [ngTemplateOutlet]="group"></ng-container>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        <ng-container [ngTemplateOutlet]="recipeName"></ng-container>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="12">
        <ng-container [ngTemplateOutlet]="mobileUOMCost"></ng-container>
      </ion-col>
    </ion-row>
  </ion-col>
  <ion-col class="ellipsis" size="0.5" offset="0.5">
    <ng-container [ngTemplateOutlet]="ellipsis"></ng-container>
  </ion-col>
</ng-template>

<ion-card
  [attr.data-cy]="'recipe-card-' + cardData.index"
  [class.selected-card]="cardData.isSelected"
  [class.mobile-card]="platform === platformRef.mobile"
>
  <ion-row
    data-cy="recipe-card"
    class="recipe-card"
    [ngClass]="
      platform !== platformRef.desktop
        ? platform === platformRef.tablet
          ? 'tablet'
          : 'mobile'
        : 'desktop'
    "
    (click)="onCardClick($event)"
  >
    <ng-container
      *ngIf="platform !== platformRef.mobile"
      [ngTemplateOutlet]="desktopTabletMain"
    ></ng-container>
    <ng-container
      *ngIf="platform === platformRef.mobile"
      [ngTemplateOutlet]="mobileMain"
    ></ng-container>
  </ion-row>
</ion-card>
